import { render, staticRenderFns } from "./PostStudy.vue?vue&type=template&id=b4200192"
import script from "./PostStudy.vue?vue&type=script&lang=js"
export * from "./PostStudy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports